<template>
  <div class="w-full bg-gray-light">
    <div class="px-2 my-4 sm:px-6">
      <Breadcrumbs class="mb-2" :crumbs="crumbs"/>
      <div
        class="flex flex-wrap justify-between align-baseline border-b-2 border-blue-base mb-2"
      >
        <h1 class="text-blue-base uppercase pt-5">Pontos de Seção</h1>
        <router-link
          tag="button"
          class="px-2 py-2 mb-2 form-new-blue sm:py-1"
          :to="{ name: 'lines.sectionpoints.create' }"
        >
          <div class="flex items-center justify-center">
            <Icon icon="plus" class="h-4 mr-1 fill-current"/>
            Novo Ponto de Seção
          </div>
        </router-link>
      </div>

      <form class="p-2" @submit.prevent="searchLines">
        <h1 class="text-blue-base mb-2">Filtre sua pesquisa</h1>
        <div class="grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-5">
          <div
            class="grid sm:col-span-5 md:col-span-5 lg:col-span-4 lg:grid-cols-4 lg:w-11/12 gap-4"
          >
            <SearchSelect
              :selected.sync="localidadeFilter"
              :search-keys="[]"
              :search-remote="true"
              :lazy-load="true"
              options-url="/api/lines/section-point/search/local/"
              :digits-before-search="3"
              option-key="nmlocalidade"
              optional-placeholder-icon="icon_flag.svg"
              optional-carret-icon="icon_caret.svg"
              field-class="py-2"
              name="nmlocalidade"
              :option-value="
                                localidade =>
                                    capitalize(
                                        localidade.name ||
                                            localidade.nmlocalidade
                                    )
                            "
              @changed="changeLocalidadeFilter"
            />
            <input
              v-model="filters.delocalidade"
              name="delocalidade"
              type="text"
              class="form-input h-8"
              placeholder="Descrição"
            >
            <SearchSelect
              :selected.sync="municipioFilter"
              :search-keys="[]"
              :search-remote="true"
              :lazy-load="true"
              options-url="/api/lines/section-point/search/city/"
              :digits-before-search="3"
              option-key="name"
              optional-placeholder-icon="icon_flag.svg"
              optional-carret-icon="icon_caret.svg"
              field-class="py-2"
              name="name"
              :option-value="
                                municipio =>
                                    capitalize(municipio.name || municipio)
                            "
              @changed="changeMunicipioFilter"
            />
            <SearchSelect
              :selected.sync="situacaoFilter"
              :search-keys="[]"
              :options="situacaoOptions"
              option-key="id"
              :option-value="situacao => situacao.name"
              optional-placeholder-icon="icon_flag.svg"
              optional-carret-icon="icon_caret.svg"
              field-class="py-2"
              name="flsituacao"
              @changed="changeSituacaoFilter"
            />
          </div>
          <div
            class="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-2 sm:w-full justify-end lg:mr-3 h-8 pt-2 lg:pt-0 gap-2 lg:gap-0"
          >
            <button
              class="flex sm:col-span-1 md:col-span-1 lg:col-span-1 justify-center items-center form-red text-xs uppercase"
              type="button"
              @click="cleanFilters"
            >
              Limpar
            </button>
            <button
              class="flex sm:col-span-1 md:col-span-1 lg:col-span-1 justify-center items-center form-submit lg:ml-1"
              type="submit"
            >
              Pesquisar
            </button>
          </div>
        </div>
      </form>

      <div class="p-2">
        <SectionPointsList ref="table" :filters="filters"/>
      </div>
    </div>
  </div>
</template>

<script>
  // Importa componentes e funções utilitárias utilizadas neste componente
  import Breadcrumbs from "@/core/components/Breadcrumbs"
  import SectionPointsList from "@/domains/lines/views/sectionPoints/partials/SectionPointsList"
  import Icon from "@/core/components/Icon"
  import SearchSelect from "@/core/components/SearchSelect.vue"

  export default {
    // Declara os componentes filhos que serão utilizados no template
    components: {
      Breadcrumbs,
      SectionPointsList,
      Icon,
      SearchSelect,
    },
    data: () => ({
      // Título da página
      title: "Pontos de secao",

      // Lista de navegação (breadcrumbs)
      crumbs: [
        { name: "Início", path: "index" },
        { name: "Linhas", path: "lines.index" },
        { name: "Pontos de Seção", path: "lines.sectionpoints" },
      ],

      // Filtros que serão enviados para a API
      filters: {
        nmlocalidade: { id: 0, name: "Localidade" },
        delocalidade: "",
        nmmunicipio: { id: 0, name: "Município" },
        flsituacao: { id: 0, name: "Situação" },
      },

      // Valores atuais selecionados nos filtros (visuais)
      localidadeFilter: { id: 0, name: "Localidade" },
      municipioFilter: { id: 0, name: "Município" },
      situacaoFilter: { id: 0, name: "Situação" },

      // Opções disponíveis para o filtro de situação
      situacaoOptions: [
        { id: 1, name: "ATIVO" },
        { id: 2, name: "INATIVO" },
        { id: 3, name: "AGUARDANDO AJUSTE" },
      ],
    }),

    methods: {
      // Capitaliza cada palavra de uma string, deixando a primeira letra maiúscula
      capitalize(string) {
        if (!string) return "" // Retorna string vazia se string for undefined ou null
        let arrayPalavras = string.split(" ")
        let arrayPalavrasCapitalized = arrayPalavras.map((palavra) => {
          return (
            palavra.charAt(0).toUpperCase() + palavra.slice(1).toLowerCase()
          )
        })
        return arrayPalavrasCapitalized.join(" ")
      },

      // Altera o filtro de localidade com base no item selecionado
      changeLocalidadeFilter(localidade) {
        this.localidadeFilter = {
          id: localidade?.nmlocalidade ? 1 : 0,
          name:
            localidade && localidade.nmlocalidade
              ? this.capitalize(localidade.nmlocalidade)
              : "Localidade",
        }
        this.filters.nmlocalidade = this.localidadeFilter
      },

      // Altera o filtro de município com base no item selecionado
      changeMunicipioFilter(municipio) {
        this.municipioFilter = {
          id: municipio?.id || 0,
          name:
            municipio && municipio.name
              ? this.capitalize(municipio.name)
              : "Município",
        }
        this.filters.nmmunicipio = this.municipioFilter
      },

      // Altera o filtro de situação com base no item selecionado
      changeSituacaoFilter(situacao) {
        this.situacaoFilter = {
          id: situacao?.id || 0,
          name: situacao?.name || "Situação",
        }
        this.filters.flsituacao = this.situacaoFilter
      },

      // Limpa todos os filtros e reseta os valores padrões
      cleanFilters() {
        this.localidadeFilter = { id: 0, name: "Localidade" }
        this.municipioFilter = { id: 0, name: "Município" }
        this.situacaoFilter = { id: 0, name: "Situação" }

        this.filters = {
          nmlocalidade: { id: 0, name: "Localidade" },
          delocalidade: "",
          nmmunicipio: { id: 0, name: "Município" },
          flsituacao: { id: 0, name: "Situação" },
        }

        // SearchSelect para atualizar seu estado
        this.$nextTick(() => {
          this.$router.push({
            name: "lines.sectionpoints",
            query: {
              page: 1,
            },
          })
        })
      },

      // Executa a busca filtrando os dados conforme os filtros definidos
      searchLines() {
        const filtersForApi = {}

        // Adiciona nmlocalidade apenas se não for o valor padrão e tiver um id válido
        if (
          this.filters.nmlocalidade.id !== 0 &&
          this.filters.nmlocalidade.name !== "Localidade"
        ) {
          filtersForApi.localidade = this.filters.nmlocalidade.name
        }

        // Adiciona delocalidade apenas se não estiver vazio
        if (this.filters.delocalidade) {
          filtersForApi.descricao = this.filters.delocalidade
        }

        // Adiciona nmmunicipio apenas se não for o valor padrão e tiver um id válido
        if (
          this.filters.nmmunicipio.id !== 0 &&
          this.filters.nmmunicipio.name !== "Município"
        ) {
          filtersForApi.municipio = this.filters.nmmunicipio.name
        }

        // Adiciona flsituacao apenas se não for o valor padrão
        if (this.filters.flsituacao.id !== 0) {
          filtersForApi.situacao = this.filters.flsituacao.id
        }

        // Recarrega a lista de pontos de seção com os filtros aplicados
        this.$router.push({
          name: "lines.sectionpoints",
          query: {
            page: 1,
            ...filtersForApi,
          },
        })
      },
    },
  }
</script>
